<template>
<div class="container-fluid public-view" style="height: 100%;">
    <div class="row" style="height: 100%;">
        <div class="public-side" v-bind:style="{ backgroundSize: 'cover', backgroundImage: `url('${backImg}')` }">
            <div class="public-logo">
                <img src="../assets/infinite-logo-white.svg" />
            </div>
        </div>
        <div class="public-main">
            <div id="main-tabs" class="scroll-y">
                <div class="tab-content">
                    <div class="panel" v-if="step == 'wait-for-email'">
                        <div class="row">
                            <div class="col-12 form-group">
                                <h1 class="public-header">Account Setup</h1>
                                <h2 class="public-subhead">Email Confirmation</h2>
                                <p class="public-description">
                                    An e-mail has been sent to {{ email }}. Please click the link in the e-mail to continue<br/><br/>
                                    If you have not received it <a href="#" @click.prevent="() => { email = null; waitForEmail = false; }">click here</a> to try again
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="panel" v-if="step == 'verify'">
                        <form ref="loginForm" @submit.prevent="verify">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <h1 class="public-header">Account Setup</h1>
                                    <h2 class="public-subhead">Email Verification</h2>
                                    <div class="errortext" v-if="errorReason">{{ errorReason }}</div>
                                    <p class="public-description">Please enter your email to verify your account</p>
                                </div>
                                <div class="col-12 form-group">
                                    <label>Email</label>
                                    <input class="form-control input-sm" name="email" v-model="email" autofocus/>
                                </div>
                                <div class="col-12 form-group">
                                    <button class="btn btn-public">Next</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="panel" v-if="step == 'setup'">
                        <password-form v-if="uuid && otp" :uuid="uuid" :passcode="otp" :errorReason="errorReason"
                            @link-expired="linkIsExpired" @submit="register" />
                    </div>
                </div>
            </div>         
        </div>
    </div>
</div>
</template>

<script>
import { config } from '../config'
import Axios from 'axios';
import sideBackPic from '../assets/background-forest-blue.jpg'
import { toastService } from './utils/toast-service';
import PasswordForm from './PasswordForm.vue'
import auth from '../auth'
import loginMixin from './login-mixin'

var api = Axios.create();

export default {
    mixins: [loginMixin],
    components: { PasswordForm },
    props : {
        otp: { type: String, required: false },
        username: { type: String, required: false },
        uuid: { type: String, required: false }
    },
    computed: {
        step() {
            if(this.waitForEmail) return 'wait-for-email';
            return !this.otp ? 'verify' : 'setup';
        },
        linkExpired() {
            return this.errorCode == 'INVALID_PASSCODE';
        },
        toastError() {
            if(!this.errorCode) return null;
            var codes = {
                'INVALID_USERNAME': 'Username is invalid',
                'PASSWORD_REPEAT': 'Password and confirmation password do not match. Please re-enter your password',
                'PASSWORD_REQUIREMENTS': 'Your password did not meet the requirements',
                'INVALID_PASSCODE': 'This link has expired',
                'CANNOT_REUSE' : 'You cannot reuse this password',
                'RESET_LIMIT': 'Your password can only be reset once per day'
            }

            return codes[this.errorCode];
        },
    },
    data() {
        return {
            backImg: sideBackPic,
            password: null,
            confirmPassword: null,
            email: null,
            failed: false,
            errorCode: null,
            waitForEmail: false,
            errorReason: null
        }
    },
    methods: {
        async linkIsExpired() {
            await this.startOver();
            this.errorReason = 'This link has expired and you must request a new one';
        },
        startOver() {
            return new Promise(resolve => {
                this.$router.push('/user-registration', () => { resolve(); });
            });
        },
        async register(args) {
            let payload = {
                passcode: this.otp,
                password: args.password,
                passwordRepeat: args.confirmPassword,
                userId: this.uuid
            };

            try {
                let result = await api.post(`${config.romeApi}/authentication/registration`, payload);
                if(result.data && result.data.success) {
                    await this.login(result.data.username, args.password);
                }
                else if(result.data && !result.data.success) {
                    this.errorCode = result.data.errorReason;
                    toastService.error(this.toastError);
                }
            }
            catch(e) { this.failed = true; }
        },
        async login(username, password) {
            let result = await auth.credentials(username, password);
            if(result.authenticated) {
                await this.goToRecent();
            }
            else {
                toastService.success('Registration Complete. You may now sign in');
                this.$router.push('/login');
            }
        },
        async verify() {
            if(!this.email) {
                toastService.error('Please provide your email');
                return;
            }
            let username = encodeURIComponent(this.email);
            let url = `${config.romeApi}/authentication/registration?email=${username}`;
            try {
                let result = await api.get(url);
                if(result.data && result.data.success) {
                    this.waitForEmail = true;
                }
                else if(result.data && !result.data.success) {
                    toastService.error('We were unable to process this request. Please check the e-mail address and try again');
                }
            }
            catch(e) {
                this.failed = true;
                toastService.error('We were unable to process this request. Please check the e-mail address and try again');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/framework/Registration.vue